import { render, staticRenderFns } from "./StoreNew.vue?vue&type=template&id=3ffdd321&"
import script from "./StoreNew.vue?vue&type=script&lang=js&"
export * from "./StoreNew.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports